import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import config from 'config'
import Icon from 'srcReact/components/icons/Icon'
import history, { redirectToBack } from 'srcReact/helpers/history'
import styles from './styles.module.scss'
import SocialLinks from '../../../../../SocialLinks'
import { getDescryptedMedia } from 'srcReact/helpers/utils'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'
import ReactMenu from 'srcReact/components/common2/ReactMenu'
import LightProfileProto from 'srcReact/components/common2/LightProfileModal/LightProfilPrototype'
import { lightProfileActions } from 'srcReact/components/common2/LightProfileModal/actions'
import BackNavigation from 'srcReact/components/common2/BackNavigation'

export default function ProfileHead() {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const { profileData, userStatus } = useSelector((state) => state.myProfile)
  const { isNative, isMobile } = useSelector((state) => state.common)
  const [decryptedImage, setDecryptedImage] = useState('')
  const [pronoun, setPronoun] = useState('')
  const [decryptedCoverImage, setDecryptedCoverImage] = useState('')

  useEffect(() => {
    assignPronoun()
    if (profileData && profileData.user && profileData.user.profile_picture_data) {
      if (profileData.user.profile_picture_data) {
        const { profile_picture, is_original, original_tag, mime_type } = profileData.user.profile_picture_data
        getDescryptedMedia(profile_picture, is_original, original_tag, mime_type, profileData.user.id, true).then(
          (data) => {
            setDecryptedImage(data.img)
          }
        )
      }
      if (profileData.user.cover_picture) {
        const { path, is_original, original_tag, mime_type } = profileData.user.cover_picture
        getDescryptedMedia(path, is_original, original_tag, mime_type, profileData.user.id, true).then((data) => {
          setDecryptedCoverImage(data.img)
        })
      }
    }
  }, [profileData])

  const assignPronoun = () => {
    if (profileData.user.preferred_pronoun === 'he') {
      setPronoun(t('my_profile.pronoun.he_him'))
    } else if (profileData.user.preferred_pronoun === 'she') {
      setPronoun(t('my_profile.pronoun.she_her'))
    } else if (profileData.user.preferred_pronoun === 'they') {
      setPronoun(t('my_profile.pronoun.they_them'))
    } else if (profileData.user.preferred_pronoun === null) {
      setPronoun('')
    }
  }

  const options = () => {
    let actions = []
    actions.push({
      text: t('messenger.sendMessage'),
      onClick: () => handleOpenLightModal()
    })
    return actions
  }
  const handleOpenLightModal = () => {
    let userId = profileData && profileData.user && profileData.user.id
    if (userId) {
      const lp = new LightProfileProto()
      lp.userId = userId
      lp.screen = 'messenger'
      dispatch(lightProfileActions.openLightProfileModal(lp))
    }
  }

  return (
    <div className={`${styles.headContainer}`}>
      <div className={`${styles.backBtnWrapper}`}>
        <BackNavigation customHandleBack={() => redirectToBack(isNative)} />
        {isMobile && <ReactMenu options={options()} menuButtonCSS={styles.menuButtonCSS} menuCSS={styles.menuCSS} />}
      </div>
      <div
        className={`${styles.backgroundBlock}`}
        style={decryptedCoverImage ? { backgroundImage: `url(${decryptedCoverImage})` } : {}}>
        <div className={`${styles.profileImage}`}>
          {decryptedImage ? (
            <img src={decryptedImage} alt='' />
          ) : (
            <img src={`${config.assetUrl}/images/default_avatar.jpeg`} alt='' />
          )}
        </div>
      </div>
      <h2 className={`${styles.profileName}`}>
        {profileData.user.first_name} {profileData.user.last_name}
      </h2>
      {profileData.user.is_display_pronoun === '1' ? (
        <h2 className={`${styles.profileRole}`}>
          {pronoun} {profileData.user.current_occupation ? '|' : ''}{' '}
          {profileData.user.current_occupation.charAt(0).toUpperCase() + profileData.user.current_occupation.slice(1)}
        </h2>
      ) : (
        <h2 className={`${styles.profileRole}`}>
          {profileData.user.current_occupation.charAt(0).toUpperCase() + profileData.user.current_occupation.slice(1)}
        </h2>
      )}
      {userStatus === 'deactivated' && <ErrorMessage text={t('global.deactivatedUserMessage')} />}
      {userStatus === 'deleted' && <ErrorMessage text={t('global.deletedUserMessage')} />}
      <SocialLinks
        messenger={profileData.editable === 1 ? false : true}
        linkedin={profileData.user.linkedIn_url ? true : false}
        instagram={profileData.user.instagram_url ? true : false}
      />
    </div>
  )
}
